import { getRecaptchaResult } from 'components/recaptcha_widget/component'
import { track } from 'js/cards/common/subscribe_newsletter'
import { createAnalyticsGroup } from 'js/lib/analytics'

;(function ($) {
  $(document).ready(function () {
    var $enquiryForm = $('.listing--enquiry-form')
    var $submitButton = $('.listing--enquiry-form-submit')
    var $newsletterCheckbox = $('#listings_enquiry_subscribe_to_newsletter')

    if ($enquiryForm.length === 0) {
      return
    }

    $submitButton.on('click', async function(e) {
      e.preventDefault();
      let result = await getRecaptchaResult() // always run recaptcha *after* validation

      if (result) {
        if($newsletterCheckbox.is(':checked')) {
          track('subscribe', 'Enquiry form')
        }
        submitForm($enquiryForm[0])
      }
    })
  })
})(jQuery)

function submitForm(form) {
  if (form.requestSubmit) {
    form.requestSubmit()
  } else {
    form.submit()
  }
}


const trackClick = createAnalyticsGroup(`enquiry-confirmation-donate-button`)
const donateButton = document.querySelector('.js-enquiry-confirmation-donate-button')

if (donateButton) {
  donateButton.addEventListener('click', () => {
    trackClick('click', 'enquiry-confirmation-donate-button-click')
  })
}
